import { Injectable, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FuncaoService, LoginContabil, GlobalService, Relatorio, Ppa } from 'eddydata-lib';
import { MetaGovernoService } from 'administrativo-lib';

@Injectable({
  providedIn: 'root'
})
export class Anexo2Ppa implements OnDestroy {
  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;
  private login: LoginContabil = new LoginContabil();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected metaServico: MetaGovernoService) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public montarRelatorio(ppa: Ppa, orgaos: number[]) {
    this.metaServico.anexo2(1, 9999, ppa.id, orgaos, 0, 0, false)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado(
          'ANEXO II - PLANEJAMENTO ORÇAMENTÁRIO - PPA'
          , this.login.usuario.nome, this.login.usuario.sobrenome,
          this.login.orgao.nome, this.login.brasao,
          this.conteudo(dados.content, ppa),
          'landscape', 'ANEXO II - PPA',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          }, null, true);
      });
  }

  private conteudo(dados1: any[], ppa: Ppa): {}[] {
    if (dados1.length === 0) {
      return;
    }
    // monta o agrupamento do relatório
    const grupos1 = this.funcaoService.agrupar(dados1, ['o_codigo', 'pr_nome', 'pr_codigo', 'un_nome', 'un_codigo', 'me_especie','me_tipo',
      'me_justificativa', 'me_objetivo', 'custo1', 'custo2', 'custo3', 'custo4'],
      ['custo1', 'custo2', 'custo3', 'custo4']);
    const retorno = [];
    for (let index = 0; index < grupos1.length; index++) {
      const item1 = grupos1[index];

      retorno.push({
        text: 'DESCRIÇÃO DOS PROGRAMAS GOVERNAMENTAIS/METAS/CUSTOS', alignment: 'center',
        bold: true, fontSize: 10
      });
      retorno.push({
        text: `PPA: ${ppa.ppaperiodo.ano1} - ${ppa.ppaperiodo.ano4}`, alignment: 'center',
        bold: true, fontSize: 10
      });


      retorno.push({ text: '', margin: [0, 5] });
      retorno.push({ canvas: [{ type: 'line', x1: 1, y1: 1, x2: 780, y2: 1, lineWidth: 0.5 }] });
      retorno.push({ text: '', margin: [0, 5] });
      retorno.push({ columns: [{ text: 'ÓRGÃO: ', width: 100, bold: true }, item1.grupo['o_codigo']], margin: [0, 2] });
      retorno.push({
        columns: [{ text: 'TIPO DE PROGRAMA: ', width: 100, bold: true },
        this.globalService.obterEspecieMeta(item1.grupo['me_tipo'])], margin: [0, 2]
      });
      retorno.push({ columns: [{ text: 'PROGRAMA: ', width: 100, bold: true }, item1.grupo['pr_nome']], margin: [0, 2] });
      retorno.push({ columns: [{ text: 'CÓDIGO DO PROGRAMA: ', width: 100, bold: true }, item1.grupo['pr_codigo']], margin: [0, 2] });
      retorno.push({ columns: [{ text: 'UNIDADE RESPONSÁVEL: ', width: 100, bold: true }, item1.grupo['un_nome']], margin: [0, 2] });
      retorno.push({ columns: [{ text: 'CÓDIGO DA UNIDADE: ', width: 100, bold: true }, item1.grupo['un_codigo']], margin: [0, 2, 0, 10] });
      retorno.push({
        columns: [{ text: 'OBJETIVO:', bold: true, width: 100, margin: [0, 2, 2, 10] },
        { text: item1.grupo['me_objetivo'], width: '*', margin: [0, 2, 2, 10] }]
      });
      retorno.push({
        columns: [{ text: 'JUSTIFICATIVA:', bold: true, width: 100, margin: [0, 2, 2, 10] },
        { text: item1.grupo['me_justificativa'], width: '*', margin: [0, 2, 2, 10] }]
      });
      retorno.push({
        text: 'METAS', alignment: 'center',
        bold: true, fontSize: 10, margin: [0, 2]
      });

      let registros: {}[] = [];
      registros.push([
        { text: 'INDICADORES', bold: true, fontSize: 8, alignment: 'center' },
        { text: 'UN. MEDIDA', bold: true, fontSize: 8, alignment: 'center' },
        { text: 'INDICE RECENTE', bold: true, fontSize: 8, alignment: 'center' },
        { text: 'INDICE FUTURO', bold: true, fontSize: 8, alignment: 'center' },
        { text: 'AÇÃO', bold: true, fontSize: 8, alignment: 'center' }
      ]);
      // lista os registros do relatorio
      for (let idx = 0; idx < item1.registros.length; idx++) {
        const element1 = item1.registros[idx];
        registros.push([
          {
            text: element1 ? `${element1.in_nome}` : '', fontSize: 8
          },
          {
            text: element1 ? element1.in_unidade_medida : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_recente) : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_futuro) : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? element1.a_codigo : '', alignment: 'center',
            fontSize: 8
          }
        ]);
      }
      retorno.push({
        layout: 'linhas',
        table: {
          dontBreakRows: true,
          headerRows: 2,
          widths: [350, '*', '*', '*', '*'],
          body: registros
        }, margin: [0, 0, 0, 5]
      });
      retorno.push({
        text: 'PREVISÃO DE EVOLUÇÃO DE INDICADORES', alignment: 'center',
        bold: true, fontSize: 10, margin: [0, 2] 
      });
      registros = [];
      registros.push([
        { text: 'INDICADORES', bold: true, fontSize: 8, alignment: 'center' },
        { text: ppa.ppaperiodo.ano1, bold: true, fontSize: 8, alignment: 'center' },
        { text: ppa.ppaperiodo.ano2, bold: true, fontSize: 8, alignment: 'center' },
        { text: ppa.ppaperiodo.ano3, bold: true, fontSize: 8, alignment: 'center' },
        { text: ppa.ppaperiodo.ano4, bold: true, fontSize: 8, alignment: 'center' }
      ]);
      // lista os registros do relatorio
      for (let idx = 0; idx < item1.registros.length; idx++) {
        const element1 = item1.registros[idx];
        registros.push([
          {
            text: element1 ? `${element1.in_nome}` : '', fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_meta1) : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_meta2) : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_meta3) : '', alignment: 'center',
            fontSize: 8
          },
          {
            text: element1 ? this.funcaoService.convertToBrNumber(element1.in_meta4) : '', alignment: 'center',
            fontSize: 8
          }
        ]);
      }
      retorno.push({
        layout: 'linhas',
        table: {
          dontBreakRows: true,
          headerRows: 2,
          widths: [350, '*', '*', '*', '*'],
          body: registros
        }, margin: [0, 0, 0, 4]
      });
      retorno.push({
        columns: [{ text: 'CUSTO DO PROGRAMA: ', width: 100, bold: true },
        this.funcaoService.convertToBrNumber(+item1.grupo['custo1'] + +item1.grupo['custo2'] + +item1.grupo['custo3'] + +item1.grupo['custo4'])], margin: [0, 2]
      });

      if (index !== grupos1.length - 1) {
        retorno.push({ text: '', pageBreak: 'after' });
      }
    }

    return retorno;
  }


}
